// import Produit from './Produit';
// // import {toitureItemData} from './ToitureItem'

// const Block = ({blockTitle, blockContent, hasInput, inputDescription, inputLabel}) => {

//     return(
//         <>
//             <div className="form-container">
//   <div className="form-head">
//     {/* <p className="text-center">Je sélectionne ma couverture de toiture</p> */}
//     <p className="text-center">{blockTitle}</p>
//   </div>
//   <div className="be-form p-3 p-md-5">
//     <form action="">
//       <div className="text-center" style={{}}>
//         <div className="row select-elements">
//             {blockContent?.map((materiau, index) => (
//                 <Produit 
//                     key={index}
//                     imageUrl={materiau.imageUrl}
//                     title={materiau.title}
//                     description={materiau.description}
//                 />
//             ))}
//         </div>
//       </div>
//       {hasInput && (
//             <div className="mt-4">
//               <div className="d-flex flex-column">
//                 <label htmlFor="" className="label-be">
//                   {inputLabel || 'Votre charpente sera apparente ou non apparente :'}
//                 </label>
//                 <div className="input-wrapper">
//                   <input type="text" />
//                   <span className="unit">mm</span>
//                 </div>
//               </div>
//               <div className="to-consider">
//                 <p>{inputDescription || 'Qualité visuelle accrue pour les bois apparents'}</p>
//               </div>
//             </div>
//           )}
//       <div className="other-choice">
//         <div className="row">
//           <div className="col-12 col-md-3">
//             <div className="other-choice-box">
//               <p className="text-center">AUTRE CHOIX</p>
//             </div>
//           </div>
//           <div className="d-flex flex-column" style={{ width: 400 }}>
//             <label htmlFor="" className="label-be">
//               Quelle Isolation
//             </label>
//             <input type="text" />
//             <label htmlFor="" className="label-be mt-auto">
//               Indiquez le poids du produit
//             </label>
//             {/* <input type="text"> */}
//             <div className="input-wrapper">
//               <input type="text" />
//               <span className="unit">Kg/m²</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </form>
//   </div>
// </div>

//         </>
//     )

// }

// export default Block;

import OtherChoice from './OtherChoice';
import Produit from './Produit';
import { useState } from 'react';

const Block = ({ blockTitle, blockContent, hasInput, inputLabel, inputDescription, type, options, value, onChange, order }) => {

  const [isActiveOtherChoice, setIsActiveOtherChoice] = useState(false);

  // function moveItem(array, fromIndex, toIndex) {
  //   const updatedArray = [...array];
  //   const [movedItem] = updatedArray.splice(fromIndex, 1); // retire l'élément
  //   updatedArray.splice(toIndex, 0, movedItem); // insère à la nouvelle position
  //   return updatedArray;
  // }

  // const handleMoveField = (from, to) => {
  //   if (to < 0 || to >= fields.length) return; // éviter les débordements
  //   const newFields = moveItem(fields, from, to);
  //   setFields(newFields);
  // };

  const toggleOtherChoice = () => {
    setIsActiveOtherChoice(!isActiveOtherChoice);
    console.log('Autre Choix:',isActiveOtherChoice);
  };

  return (
    <>
      <div className="form-container">
        <div className="form-head">
          <p className="text-center">{blockTitle}{order}</p>
        </div>

        <div className="be-form p-3 p-md-5">
          <form>
            <div className="text-center">
              <div className="row select-elements">
                {blockContent?.map((materiau, index) => (
                  <Produit
                    key={index}
                    // imageUrl={materiau.imageUrl}
                    title={materiau.title}
                    description={materiau.description}
                  />
                ))}
              </div>
            </div>

            {hasInput && (
              <div className="mt-4">
                <div className="d-flex flex-column">
                  <label htmlFor="" className="label-be">
                    {inputLabel || 'Votre charpente sera apparente ou non apparente :'}
                  </label>

                  <div className="input-wrapper">
                    {type === 'text' && (
                      <input type="text" className="form-control" value={value} onChange={onChange} />
                    )}
                    {type === 'number' && (
                      <input type="number" className="form-control" value={value} onChange={onChange} />
                    )}
                    {type === 'date' && (
                      <input type="date" className="form-control" value={value} onChange={onChange} />
                    )}
                    {type === 'file' && (
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => onChange(e)} // tu peux stocker e.target.files[0].name si besoin
                      />
                    )}
                    {type === 'select' && (
                      <select className="form-select" value={value} onChange={onChange}>
                        <option value="">-- Sélectionner --</option>
                        {options?.map((opt, i) => (
                          <option key={i} value={opt}>{opt}</option>
                        ))}
                      </select>
                    )}

                    {(type === 'text' || type === 'number') && <span className="unit">mm</span>}
                  </div>
                </div>

                <div className="to-consider">
                  <p>{inputDescription}</p>
                </div>
              </div>
            )}
            <OtherChoice isActive={isActiveOtherChoice} onClick={toggleOtherChoice}/>
          </form>
        </div>
      </div>
      {/* <button onClick={() => handleMoveField(index, index - 1)}>⬆️ Monter</button>
      <button onClick={() => handleMoveField(index, index + 1)}>⬇️ Descendre</button> */}
    </>
  );
};

export default Block;